module.exports = __webpack_public_path__ + "static/media/BNW_Alphabet_X.b907f2ca.jpg";